/**
 *
 * @param {Object} hasSampledObj
 * @returns {boolean}
 */
const needsToBeRatedProductUtil = (hasSampledObj) => {
  if (!hasSampledObj) {
    return false
  }

  const validPssAnswers = [
    'not_like',
    'like',
    'super_like'
  ]
  return !validPssAnswers.includes(hasSampledObj.pssAnswer) && hasSampledObj.isDelivered
}

export default needsToBeRatedProductUtil

/**
 * Product needs to be rated if
 *  1 -  already sampled
 *  2 -  pss answer is not in the list of valid pss answers
 *  3 -  sample was delivered
 */
